const apiUrl = 'https://tcs-walnutcreek.pike13.com/api/v2';

export const checkNotes = (eventId) => {
  const endpoint = `/desk/event_occurrences/${eventId}/notes`;
  return fetchData(endpoint);
};

export const fetchData = (endpoint) => {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) {
    throw new Error('Access token not found');
  }

  const url = `${apiUrl}${endpoint}`;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };

  return fetch(url, { headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Request failed');
      }
      return response.json();
    })
    .catch((error) => {
      console.error(error);
      throw new Error('Failed to fetch data');
    });
};

export const postData = (endpoint, data) => {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) {
    throw new Error('Access token not found');
  }

  const url = `${apiUrl}${endpoint}`;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };

  return fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Request failed');
      }
      return response.json();
    })
    .catch((error) => {
      console.error(error);
      throw new Error('Failed to fetch data');
    });
};
